import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// eslint-disable-next-line
import { getTravelFn, saveRuleFn, getDetailFn } from 'api/approval/config';
import Org from '@/components/organization';
export default {
  components: {
    Org: Org
  },
  data: function data() {
    return {
      form: {
        staff_list: [],
        department_list: []
      },
      visible: false,
      dataForm: {},
      arr: [],
      disabled: false,
      disabledForm: true,
      // 取消数据还原
      cancelData: null,
      // 当前操作项
      currrntIndex: null
    };
  },
  mounted: function mounted() {
    this.getAll();
  },
  methods: {
    getAll: function getAll() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, staffs;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getTravelFn();
            case 2:
              res = _context.sent;
              _this.$emit('clear-loading');
              staffs = [];
              _this.arr = res.data.map(function (item) {
                item.staff_ids.forEach(function (item) {
                  staffs.push({
                    staff_id: item.staff_id,
                    staff_name: item.staff_name,
                    staff_name_en: item.staff_name_en,
                    staff_name_secondary: item.staff_name_secondary,
                    staff_name_th: item.staff_name_th,
                    avatar_url: item.avatar_url
                  });
                });
                item.staff_ids = staffs;
                item.isEdit = false;
                item.loading = false;
                return item;
              });
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    dataFormSubmit: function dataFormSubmit(item) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              item.loading = true;
              _context2.next = 3;
              return saveRuleFn(item);
            case 3:
              _this2.getAll();
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    clearHandle: function clearHandle(item, status, index) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this3.arr[index].isEdit = status || false;
              if (!status) _this3.getAll(); // 获取详情
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    // 打开弹窗
    openSel: function openSel(index) {
      this.visible = true;
      this.currrntIndex = index;
      // 当前选中项人员
      var currentSelect = this.arr[index];
      this.form.department_list = currentSelect.department_ids;
      this.form.staff_list = currentSelect.staff_ids;
    },
    handlerSelected: function handlerSelected(params) {
      var current = this.arr[this.currrntIndex];
      current.staff_ids = params.staffIds;
      current.department_ids = params.depIds;
      current.num = params.staffCount;
      this.form.department_list = params.dept_list;
      this.form.staff_list = params.staff_list;
    },
    // 计算部门人数
    handlerDepPersonCount: function handlerDepPersonCount(dep) {
      var count = 0;
      for (var i in dep) {
        count += dep[i].staff_count;
      }
      return count;
    }
  }
};